function JsonNullToSpace(obj) {
  for (let key in obj){ 
    let value = obj[key];
    if (value === null) {
      obj[key] = '';
    } else if (typeof value === 'object') {
      JsonNullToSpace(value);
    }
  }
}

export default JsonNullToSpace;


// WEBPACK FOOTER //
// ./client/utils/jsonNullToSpace.js